const localize = (prop: Localized, language: string, strict?: boolean): string => {
  if (!prop || prop.length === 0) {
    return '';
  }

  const translation = prop.find(t => t.lang === language);

  if (translation) {
    return translation.value;
  }
  if (strict) {
    return '';
  }
  const englishTranslation = prop.find(t => t.lang === 'en');
  return englishTranslation?.value || prop[0].value;
};

export default localize;
